import React from 'react';
import { useLocale } from '../../../context/LocaleContext';
import s from './dayView.module.css';

// The sidebar summary. Four numbers, no chart — this is a glance, not a report.

function Stat({ value, label, good = false }) {
  return (
    <div>
      <div className={good ? s.glanceValueGood : s.glanceValue}>{value}</div>
      <div className={s.glanceLabel}>{label}</div>
    </div>
  );
}

// `teachingHoursText` is the core's (`toFixed(1)` of the hours), so the figure
// reads the same here and on both phones — with the Region's decimal
// separator, `1,5` in Germany (`shownDecimal`, #526).
export default function DayGlance({ lessonCount, teachingHoursText, attendedCount, billedMinor }) {
  const { formatMoney, shownDecimal } = useLocale();
  return (
    <div className={s.card}>
      <div className={s.eyebrow}>Today at a glance</div>
      <div className={s.glanceGrid}>
        <Stat value={lessonCount} label={lessonCount === 1 ? 'lesson today' : 'lessons today'} />
        <Stat value={shownDecimal(teachingHoursText)} label="teaching hours" />
        <Stat value={attendedCount} label="attended" good={attendedCount > 0} />
        <Stat value={formatMoney(billedMinor)} label="billed today" />
      </div>
    </div>
  );
}
